module.exports = __webpack_public_path__ + "static/media/icon_calendar_summary.666890f4.svg";